/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  GetTokensParams,
  MinimalToken,
  TokenGenerateRequest,
  TokenGenerateResponse,
  TokenRemoveRequest
} from '../../model';





/**
 * Can be used for generation an URL for login without user/pass.
 * @summary Generates URL for login
 */
export const generateLoginURL = (
    tokenGenerateRequest: TokenGenerateRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TokenGenerateResponse>> => {
    
    
    return axios.default.post(
      `/api/v1.1/urls/generate`,
      tokenGenerateRequest,options
    );
  }



export const getGenerateLoginURLMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoginURL>>, TError,{data: TokenGenerateRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof generateLoginURL>>, TError,{data: TokenGenerateRequest}, TContext> => {

const mutationKey = ['generateLoginURL'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof generateLoginURL>>, {data: TokenGenerateRequest}> = (props) => {
          const {data} = props ?? {};

          return  generateLoginURL(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GenerateLoginURLMutationResult = NonNullable<Awaited<ReturnType<typeof generateLoginURL>>>
    export type GenerateLoginURLMutationBody = TokenGenerateRequest
    export type GenerateLoginURLMutationError = AxiosError<unknown>

    /**
 * @summary Generates URL for login
 */
export const useGenerateLoginURL = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof generateLoginURL>>, TError,{data: TokenGenerateRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof generateLoginURL>>,
        TError,
        {data: TokenGenerateRequest},
        TContext
      > => {

      const mutationOptions = getGenerateLoginURLMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Can be used to disable a token
 * @summary Disable token by id
 */
export const disableToken = (
    tokenId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/urls/disable/${tokenId}`,undefined,options
    );
  }



export const getDisableTokenMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableToken>>, TError,{tokenId: number}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof disableToken>>, TError,{tokenId: number}, TContext> => {

const mutationKey = ['disableToken'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof disableToken>>, {tokenId: number}> = (props) => {
          const {tokenId} = props ?? {};

          return  disableToken(tokenId,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DisableTokenMutationResult = NonNullable<Awaited<ReturnType<typeof disableToken>>>
    
    export type DisableTokenMutationError = AxiosError<unknown>

    /**
 * @summary Disable token by id
 */
export const useDisableToken = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof disableToken>>, TError,{tokenId: number}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof disableToken>>,
        TError,
        {tokenId: number},
        TContext
      > => {

      const mutationOptions = getDisableTokenMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Can be used for listing tokens.
 * @summary Get tokens in JSON
 */
export const getTokens = (
    params: GetTokensParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<MinimalToken[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/urls/tokens`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetTokensQueryKey = (params?: GetTokensParams,) => {
    return [
    `/api/v1.1/urls/tokens`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTokensQueryOptions = <TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(params: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTokensQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTokens>>> = ({ signal }) => getTokens(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTokensQueryResult = NonNullable<Awaited<ReturnType<typeof getTokens>>>
export type GetTokensQueryError = AxiosError<unknown>


export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokens>>,
          TError,
          Awaited<ReturnType<typeof getTokens>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTokens>>,
          TError,
          Awaited<ReturnType<typeof getTokens>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tokens in JSON
 */

export function useGetTokens<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTokensQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTokensSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(params: GetTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTokensQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTokens>>> = ({ signal }) => getTokens(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTokensSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getTokens>>>
export type GetTokensSuspenseQueryError = AxiosError<unknown>


export function useGetTokensSuspense<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokensSuspense<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTokensSuspense<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get tokens in JSON
 */

export function useGetTokensSuspense<TData = Awaited<ReturnType<typeof getTokens>>, TError = AxiosError<unknown>>(
 params: GetTokensParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getTokens>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTokensSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Can be used for removing tokens by id.
 * @summary Removes related tokens
 */
export const removeTokens = (
    tokenRemoveRequest: TokenRemoveRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.delete(
      `/api/v1.1/urls`,{data:
      tokenRemoveRequest, ...options}
    );
  }



export const getRemoveTokensMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTokens>>, TError,{data: TokenRemoveRequest}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof removeTokens>>, TError,{data: TokenRemoveRequest}, TContext> => {

const mutationKey = ['removeTokens'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeTokens>>, {data: TokenRemoveRequest}> = (props) => {
          const {data} = props ?? {};

          return  removeTokens(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RemoveTokensMutationResult = NonNullable<Awaited<ReturnType<typeof removeTokens>>>
    export type RemoveTokensMutationBody = TokenRemoveRequest
    export type RemoveTokensMutationError = AxiosError<unknown>

    /**
 * @summary Removes related tokens
 */
export const useRemoveTokens = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeTokens>>, TError,{data: TokenRemoveRequest}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeTokens>>,
        TError,
        {data: TokenRemoveRequest},
        TContext
      > => {

      const mutationOptions = getRemoveTokensMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    